export default __webpack_public_path__ + "static/media/analytics-inactive.7875f6e5.svg";